// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"SearchInput_inputWrapper__1B3rA","searchIcon":"SearchInput_searchIcon__3s-6p","input":"SearchInput_input__367JL","closeIcon":"SearchInput_closeIcon__1FU_o"};